class DualDrawer {
  constructor() {
    this.container = document.getElementById("DualDrawer");
    if (!this.container) return;

    this.links = this.container.querySelectorAll(".dual-drawer__link[data-target]");
    this.submenus = this.container.querySelectorAll(".dual-drawer__submenu");
    this.closeElements = this.container.querySelectorAll("[data-close]");

    this.container.setAttribute("inert", "");
    this.init();
  }

  init() {
    // Select ALL links: both the buttons (submenus) and <a> tags (direct)
    const allNavLinks = this.container.querySelectorAll(".dual-drawer__link");

    allNavLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        if (window.innerWidth <= 1000) return;
        const target = link.getAttribute("data-target");
        if (target) {
          this.switchSubmenu(target);
        }
      });

      // Handle clicks for mobile or manual triggering
      link.addEventListener("click", (e) => {
        if (link.tagName === "BUTTON") {
          e.preventDefault();
          this.switchSubmenu(link.getAttribute("data-target"));
        }
      });
    });

    // Close logic remains the same
    this.closeElements.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    });

    document.addEventListener("click", (event) => {
      const openBtn = document.querySelector(".open__sidebar_menu");
      if (
        this.container.classList.contains("is-open") &&
        !document.querySelector(".dual-drawer__inner").contains(event.target) &&
        (!openBtn || !openBtn.contains(event.target))
      ) {
        this.close();
      }
    });

    // Back button — mobile only
    const backBtn = this.container.querySelector("#dual-drawer-back");
    if (backBtn) {
      backBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        const content = this.container.querySelector(".dual-drawer__content");
        if (content) content.classList.remove("is-mobile-active");
      });
    }

    // Reset mobile state on resize to desktop
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1000) {
        const content = this.container.querySelector(".dual-drawer__content");
        if (content) content.classList.remove("is-mobile-active");
      }
    });
  }

  switchSubmenu(handle) {
    const isMobile = window.innerWidth <= 1000;

    // 1. Update Submenus
    this.submenus.forEach((menu) => {
      if (menu.dataset.menu === handle) {
        menu.classList.add("is-active");
        menu.style.visibility = "visible";
        menu.style.opacity = "1";
      } else {
        menu.classList.remove("is-active");
        menu.style.visibility = "hidden";
        menu.style.opacity = "0";
      }
    });

    // 2. Update Link UI
    const allNavLinks = this.container.querySelectorAll(".dual-drawer__link");
    allNavLinks.forEach((link) => {
      const isMatch = link.getAttribute("data-target") === handle;
      link.setAttribute("aria-expanded", isMatch ? "true" : "false");
      link.style.opacity = isMatch ? "1" : "0.4";
    });

    // 3. On mobile: slide content panel in over nav
    if (isMobile) {
      const content = this.container.querySelector(".dual-drawer__content");
      const backLabel = this.container.querySelector(".dual-drawer__back-label");
      if (content) content.classList.add("is-mobile-active");

      // Update back label to show which section was entered
      if (backLabel) {
        const trigger = this.container.querySelector(`[data-target="${handle}"] .nav-text`);
        backLabel.textContent = trigger ? trigger.textContent.trim() : "Back";
      }
    }
  }

  open() {
    this.container.removeAttribute("inert");
    this.container.classList.add("is-open");
    this.container.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden"); // Standard Trade/Dawn class

    // Auto-activate first submenu on desktop only
    if (this.links.length > 0 && window.innerWidth > 1000) {
      this.switchSubmenu(this.links[0].dataset.target);
    }
  }

  close() {
    this.container.classList.remove("is-open");
    this.container.setAttribute("inert", "");
    this.container.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");

    // Reset mobile panel state
    const content = this.container.querySelector(".dual-drawer__content");
    if (content) content.classList.remove("is-mobile-active");

    // Reset nav link opacity and aria state
    const allNavLinks = this.container.querySelectorAll(".dual-drawer__link");
    allNavLinks.forEach((link) => {
      link.style.opacity = "";
      link.setAttribute("aria-expanded", "false");
    });
  }
}

// Initialize and expose to window so header trigger can find it
document.addEventListener("DOMContentLoaded", () => {
  window.dualDrawer = new DualDrawer();
});
